<template>
    <v-card>
        <v-card-title>
            <h3>Subscriptions</h3>
            <v-spacer />
            <v-col>
                <ApolloQuery :query="require('@/graphql/client/clientsDropdown.gql')">
                    <template v-slot="{ result: { loading, error, data } }">
                        <v-autocomplete
                            v-if="data"
                            :items="data.allClients"
                            :loading="loading"
                            item-text="name"
                            item-value="id"
                            v-model="client_id"
                            label="Client"
                            clearable
                            hide-details
                        />
                        <v-autocomplete v-else label="Loading Clients" />
                    </template>
                </ApolloQuery>
            </v-col>
            <v-col>
                <v-autocomplete
                    :items="statuses"
                    item-text="name"
                    item-value="id"
                    v-model="status"
                    label="Status"
                    clearable
                    hide-details
                />
            </v-col>
            <v-col>
                <ApolloQuery :query="require('@/graphql/price/allPrices.gql')">
                    <template v-slot="{ result: { loading, error, data } }">
                        <v-autocomplete
                            v-if="data"
                            :items="data.allPrices"
                            :loading="loading"
                            item-text="name"
                            item-value="id"
                            v-model="tier"
                            label="Tier"
                            clearable
                            hide-details
                        />
                        <v-autocomplete v-else label="Loading tiers" />
                    </template>
                </ApolloQuery>
            </v-col>
        </v-card-title>
        <v-card-text>
            <subscriptions-grid
                :client_id.sync="client_id"
                :tier="tier"
                :status="status"
                :reload.sync="reloadVar"
                @show-subscription="showSubscription"
            />
        </v-card-text>
        <v-dialog
            @input="toggleSubscriptionDialog"
            v-model="showSubscriptionDialog"
            max-width="800"
        >
            <subscription-dialog
                @close="closeSubscriptionDialog"
                :subscription.sync="subscription"
            />
        </v-dialog>
    </v-card>
</template>
<script>
import subscriptionStatuses from '@/subscriptionStatuses'
import SubscriptionsGrid from '@/views/subscriptions/SubscriptionsGrid.vue'
import SubscriptionDialog from '@/views/subscriptions/SubscriptionDialog.vue'

export default {
    name: 'subscriptions',
    components: {
        SubscriptionDialog,
        SubscriptionsGrid,
    },
    data() {
        return {
            reloadVar: 0,
            client_id: this.$route.query.client_id || '',
            tier: null,
            statuses: subscriptionStatuses,
            status: null,
            showSubscriptionDialog: false,
            subscription: null,
        }
    },
    methods: {
        reloadGrid: function() {
            this.reloadVar++
        },
        showSubscription: function(subscription) {
            this.showSubscriptionDialog = true

            this.$apollo
                .mutate({
                    // Query
                    mutation: require('@/graphql/subscription/subscription.gql'),
                    variables: {id: subscription.id}
                })
                .then(({ data }) => {
                    this.subscription = data.subscription;
                })
        },
        toggleSubscriptionDialog: function(showSubscriptionDialog) {
            if (! showSubscriptionDialog) {
                this.subscription = null
            }
        },
        closeSubscriptionDialog: function() {
            this.showSubscriptionDialog = false
            this.subscription = null
        },
    },
}
</script>
